export default __webpack_public_path__ + "static/media/waitlisted-request.6085189c.svg";